import React from "react";
import ProfessorsList from "./professors/ProfessorsList";
import Navbar from "../../../Navbar";
import Footer from "../../../Footer";

const ManageInstitute = () => {
  const MemberTyp = localStorage.getItem("MemberType");

  return (
    <>
      {/* <Navbar MemberType={MemberTyp} /> */}
      <div className="main-content-gap">
        <div className="container">
          <ProfessorsList />
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default ManageInstitute;
